import { MiniHeroShadowVariant } from '../MiniHero.types';

export function getShadowGradientDirection(variant: MiniHeroShadowVariant) {
  switch (variant) {
    case 'leftToRight':
      return 'to right';
    case 'rightToLeft':
      return 'to left';
    case 'topToBottom':
      return 'to bottom';
    case 'bottomToTop':
      return 'to top';
  }
}
